import { Button, Icon, IconIdentifier } from '@aus-platform/design-system';
import { type GenerateDEMConfirmationType } from './types';

export const GenerateDEMConfirmation: React.FC<GenerateDEMConfirmationType> = ({
  setIsFormSubmitted,
}) => {
  return (
    <div className="generate-dem__confirmation">
      <Icon identifier={IconIdentifier.Loading} size={78} />

      <div className="generate-dem__confirmation__title">
        Generating DEM
      </div>

      <div className="generate-dem__confirmation__description">
        Once the DEM is ready, it will be available as the captured DEM for the
        selected iteration.
      </div>

      <div className="generate-dem__confirmation__actions">
        <Button onClick={() => setIsFormSubmitted(false)}>
          Generate New Request
        </Button>
      </div>
    </div>
  );
};
